import { ChangePhoneTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ChangePhoneTrackingSchema: Record<ChangePhoneTrackingPoint, string> = {
  [ChangePhoneTrackingPoint.ChangePhoneSuccessAction]:
    '383755ec-8b18-4a06-aeb2-6f72120a3ffe',
  [ChangePhoneTrackingPoint.ChangePhoneFailAction]:
    '8dc72035-81d3-4322-bf02-d3c8cb0912a9',
  [ChangePhoneTrackingPoint.ChangePhoneRateLimitPopupImpression]:
    '37743d56-223d-41a9-91bb-fc9f97b34084',
};

export const getChangePhonePageTypeAndSchema = (
  trackingPoint: ChangePhoneTrackingPoint
) => {
  return {
    page_type: PageType.ChangePhonePage,
    schema: ChangePhoneTrackingSchema[trackingPoint],
  };
};
